// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ReferralResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type ReferralApiResponse = {
	company: string;
	firstName: string;
	lastName: string;
	jobFunction: string;
	email: string;
	phone: string;
	advice: string | null;
	createdAt: string;
};

export type Referral = {
	company: string;
	firstName: string;
	lastName: string;
	jobFunction: string;
	email: string;
	phone: string;
	advice: string | null;
	createdAt: DateTime;
};

export function hydrateReferral(data: ReferralApiResponse): Referral {
	return {
		...data,
		createdAt: DateTimefromISO(data.createdAt)!,
	};
}